import React from "react";

export const SadIcon = () => (
    <i className="icon ion-sad" />
);
